import { render, staticRenderFns } from "./ScreenshotButton.vue?vue&type=template&id=6a4060be"
import script from "./ScreenshotButton.vue?vue&type=script&lang=js"
export * from "./ScreenshotButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports